import React from 'react'

const Informations = ({ items }) => {
    return (
        items.map((item, i) => (
            <div key={`informations-${i}`}>
                <i style={{ minWidth: '2rem', fontSize: 'small', textAlign: 'center' }} className={`fa ${item.icon}`}></i>
                <span>{item.text}</span><br />
            </div>
        ))
    )
}

export default Informations